import { Box, Typography } from '@mui/material';
import { Colors, MobilePadding } from 'pages';
import { LogoCarousel } from './LogoCarousel';
export const Partners = () => {
  return <Box sx={{
    backgroundColor: Colors.White,
    padding: {
      xs: MobilePadding,
      md: '0 76px 36px 76px'
    },
    textAlign: 'center'
  }}>
      <Typography sx={{
      color: Colors.RiverBed,
      textAlign: 'center',
      textTransform: 'uppercase',
      fontWeight: 600,
      fontSize: '14px',
      mb: '1rem'
    }}>
        Lectrium works with 200+ forward thinking dealerships
      </Typography>

      <LogoCarousel />
    </Box>;
};